import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_NETWORK_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_NETWORK_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
};
export function networkAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_NETWORK_AUTH_MEMBER_PROPS_FIELDS;
    if (fields === 'all')
        fields = ALL_NETWORK_AUTH_MEMBER_PROPS_FIELDS;
    return `
    context
    scopes
    ${fields.permissions
        ? `
      permissions {
        ${actionPermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=networkAuthMemberProps.fields.js.map